var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationPinGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "location-pin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location-pin"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 36 0 36 36 0 36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,3 C12.195,3 7.5,7.695 7.5,13.5 C7.5,21.375 18,33 18,33 C18,33 28.5,21.375 28.5,13.5 C28.5,7.695 23.805,3 18,3 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    strokeWidth: 1,
    d: "M18,3 C12.195,3 7.5,7.695 7.5,13.5 C7.5,21.375 18,33 18,33 C18,33 28.5,21.375 28.5,13.5 C28.5,7.695 23.805,3 18,3 Z M18,17.25 C15.93,17.25 14.25,15.57 14.25,13.5 C14.25,11.43 15.93,9.75 18,9.75 C20.07,9.75 21.75,11.43 21.75,13.5 C21.75,15.57 20.07,17.25 18,17.25 Z",
    id: "Shape",
    fill: "#27ae60",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinGreen);
export default __webpack_public_path__ + "static/media/location-pin-green.3fcc064fd80271ab46bbc287edb86510.svg";
export { ForwardRef as ReactComponent };